import React, { useState } from "react";
import { PrimaryButton, Stack, Text } from "@fluentui/react";

export interface ReportNotFoundErrorContentProps {
    currentUserEmail: string;
    onLogoutButtonClick: () => Promise<void>;
    onRefreshPermissionsClick: () => Promise<void>;
};

const ReportNotFoundErrorContent: React.FC<ReportNotFoundErrorContentProps> = props => {

    const [loading, setLoading] = useState(false);

    const onLogoutButtonClick = async () => {
        setLoading(true);
        await props.onLogoutButtonClick();
    };

    const onRefreshPermissionsClick = async () => {
        setLoading(true);
        await props.onRefreshPermissionsClick();
    };

    return (
        <Stack horizontalAlign="center" verticalAlign="center" tokens={{childrenGap: 10}} styles={{root: {textAlign: "center"}}}>
            <Text>Raport nie istnieje lub nie posiadasz wystarczających uprawnień aby go wyświetlić</Text>
            <Text>Jesteś obecnie zalogowany/a jako: <strong>{props.currentUserEmail}</strong></Text>
            
            <Text>Jeśli Twoje uprawnienia do raportów mogły się w ostatnim czasie zmienić, spróbuj wymusić odświeżenie uprawnień</Text>
            <PrimaryButton text="Odśwież uprawnienia" onClick={onRefreshPermissionsClick} disabled={loading} />

            <Text>Jeśli chcesz wylogować się z obecnego konta i zalogować ponownie z wykorzystaniem innego konta, naciśnij poniższy przycisk</Text>
            <PrimaryButton text="Wyloguj się" onClick={onLogoutButtonClick} disabled={loading} />
        </Stack>
    );
};

export default ReportNotFoundErrorContent;
